<template>
    <div data-test="event-calendar-preview">
        <FullCalendar
            :items="items"
            :locale="locale"
            :initial-month="initialMonth"
            :initial-year="initialYear"
            :primary-color="state.buttonColor"
            :secondary-color="state.buttonTextColor"
            @item-click="onItemPreview"
            @item-show-more-click="onItemShowMoreClick"
            @month-change="onMonthChange"
        />
        <template v-if="!isImageModalVisible">
            <EventCalendarEventModal
                v-if="selectedItem"
                id="event-calendar-preview-event-modal"
                :item="selectedItem"
                @close="selectedItem = null"
            />
            <EventCalendarItemsModal
                v-else-if="selectedItems.length"
                :items="selectedItems"
                :selected-date="selectedDate"
                @on-item-click="onItemPreview"
                @close="onCloseSelectedItems"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
    import FullCalendar from '~/components/shared/FullCalendar.vue';
    import { useI18n } from 'vue-i18n';
    import { defineAsyncComponent } from 'vue';
    import { useEventCalendarPreview } from '~/composables/eventCalendarPreview';
    import { useAccountStore } from '~/stores/accountStore';
    import { storeToRefs } from 'pinia';
    import { useEventCalendarStore } from '~/stores/eventCalendar';
    import { useModalStore } from '~/stores/modalStore';

    const EventCalendarItemsModal = defineAsyncComponent(() => import('~/components/eventCalendar/EventCalendarItemsModal.vue'));
    const EventCalendarEventModal = defineAsyncComponent(() => import('~/components/eventCalendar/EventCalendarEventModal.vue'));

    const { locale } = useI18n();
    const { state } = storeToRefs(useAccountStore());
    const { showModal: isImageModalVisible } = storeToRefs(useModalStore());
    const { validFrom } = storeToRefs(useEventCalendarStore());

    const {
        items,
        initialMonth,
        initialYear,
        selectedDate,
        selectedItem,
        selectedItems,
        onItemPreview,
        onMonthChange,
        onItemShowMoreClick,
        onCloseSelectedItems,
        fetchEventCalendarByMonth
    } = useEventCalendarPreview();

    fetchEventCalendarByMonth(validFrom.value);
</script>
